<!-- 底部按钮 -->
<template>
  <div class='room_footer_wrap'>
    <div class="footer_left">
      <div class="price">
        <!-- <span
          v-if="this.$root.language == 'en'"
          class="price_tips"
        >{{$t('hotel.start')}}</span> -->
        {{currency}}{{price}}<span class="price_tips">{{$t('hotel.start')}}</span>
      </div>
      <div
        v-if="ismarketprice && marketprice"
        class="market_price"
      >{{currency}}{{marketprice ? marketprice : ''}}</div>
    </div>
    <div
      class="footer_right"
      @click="wannaPickRoom"
    >{{$t('hotel.roomTypeBtn')}}</div>
  </div>
</template>

<script>
export default {
  name: 'RoomFooter',
  props: {
    price: {
      type: [Number, String],
      default: 0
    },
    ismarketprice: {
      type: Number,
      default: 0
    },
    marketprice: {
      type: Number,
      default: 0
    },
    currency: {
      type: String,
      default: '￥'
    }

  },
  data() {
    return {

    };
  },

  components: {},

  methods: {
    // 点击选择房型
    wannaPickRoom() {
      this.$emit('listenwannaPickRoom')
    }
  },

  mounted() {

  },
}
</script>
<style lang='less' scoped>
.room_footer_wrap {
  position: fixed;
  width: 100%;
  bottom: 0;
  height: 60px;
  padding: 10px;
  box-sizing: border-box;
  background: #fff;
  display: flex;
  z-index: 10;
  box-shadow: 0px -1px 10px rgba(0, 0, 0, 0.1);
  .footer_left {
    flex: 1;
    display: flex;
    .price {
      font-size: 20px;
      font-weight: 700;
      letter-spacing: 0.01em;
      color: #000;
      line-height: 40px;
      .price_tips {
        font-size: 14px;
      }
    }
    .market_price {
      font-size: 12px;
      letter-spacing: 0.01em;
      color: #777;
      line-height: 48px;
      text-decoration: line-through;
    }
  }
  .footer_right {
    width: 110px;
    height: 40px;
    line-height: 40px;
    text-align: center;
    color: var(--color);
    background: var(--background);
    border-radius: 4px;
    font-size: 16px;
    font-weight: 700;
    letter-spacing: 0.01em;
  }
}
</style>